import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { navFlyoutZIndex } from '../../../../../theme/z-index';

export const useNavMenuCollapsibleDesktopItemStyles = makeStyles<
  Theme,
  { hideBottomBorder?: boolean; isSelected?: boolean }
>((theme) => ({
  menuItemsDesktop__button: {
    boxShadow: 'none!important',
    background({ isSelected }) {
      return isSelected ? 'hsla(0,0%,100%,.1)' : 'none';
    },
    color: 'white!important',
    '&.active': {
      background: 'hsla(0,0%,100%,.1)'
    },
    '&:hover': {
      background: 'hsla(0,0%,100%,.1)'
    },
    '&:last-child': {
      marginRight: 0
    },
    marginRight: '0.5rem'
  },
  menuItemsDesktop__childButton: {
    backgroundColor({ isSelected }) {
      return isSelected ? theme.palette.action.selected : 'inherit';
    }
  },
  menuItemDesktop_IconWrapper: {
    minWidth: '2.5rem'
  },
  menuItemDesktop_Icon: {
    width: '1.5rem',
    height: '1.5rem'
  },
  menuItemDesktop__nestedChevron: {
    marginLeft: theme.spacing(1),
    color: theme.palette.action.active
  },
  menuItemsDesktop__popper: {
    zIndex: navFlyoutZIndex(theme)
  }
}));
